module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row3"
  }, [_vm._l((_vm.catelist), function(row, i) {
    return (i >= 1) ? _c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsList',
          query: {
            cate_id: row.id
          }
        }),
        expression: "{name:'NewsList',query:{cate_id:row.id}}"
      }],
      attrs: {
        "src": row.pic_url
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "logo-ul"
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', [_c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id}}"
      }],
      attrs: {
        "src": row.pic_url
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8784b44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Saishizhaoshang.vue
// module id = 1317
// module chunks = 0